import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import OtherClickListener from '../../../../../../../events/OtherClickListener';
import { propArrayShape, propBool, propFunc, propNumber, } from '../../../../../../../helpers/custom-prop-types';
import { useBoolState } from '../../../../../../../helpers/use/useHook';
import GoodIcon from '../../../../../../Icon/Svg/GoodIcon';
import CharmPointRow from '../../CharmPoint/CharmPointRow';
const RightComponentSpCharmPoint = (props) => {
    const { charmPoint, charmPoints, isDisabled, onChangeCompleteInputRange, onChangeInputRange, } = props;
    const { boolState, changeFalse, changeToggle } = useBoolState();
    const ref = useRef();
    useEffect(() => {
        const index = OtherClickListener.setListener(ref.current, changeFalse);
        return () => {
            OtherClickListener.deleteListener(index);
        };
    }, [ref, changeFalse]);
    return (_jsxs("div", Object.assign({ className: 'inner_column full_screen_modal_right_range_column is_sp', ref: ref }, { children: [_jsx("div", Object.assign({ className: 'comment_button_box' }, { children: _jsxs("button", Object.assign({ className: clsx('action_button', boolState ? 'is_open' : 'is_close'), onClick: changeToggle, type: 'button' }, { children: [_jsx(GoodIcon, { className: 'svg-good-icon-sp' }), _jsxs("span", Object.assign({ className: 'action_button_text action_button_text_charm_point' }, { children: ["\u63D0\u6848", _jsx("br", {}), "\u9B45\u529B\u5EA6"] }))] })) })), boolState && (_jsx("div", Object.assign({ className: 'charmpoint_column_sp_box' }, { children: _jsx(CharmPointRow, { arrowColor: 'white', bottomRowClassName: 'charmpoint_bottom_row_sp', charmPoint: charmPoint, charmPoints: charmPoints, className: 'charmpoint_column_sp', isDisabled: isDisabled, onChange: onChangeInputRange, onChangeComplete: onChangeCompleteInputRange, topRowClassName: 'charmpoint_top_row_sp' }) })))] })));
};
RightComponentSpCharmPoint.propTypes = {
    charmPoint: propNumber().isRequired,
    charmPoints: propArrayShape().isRequired,
    isDisabled: propBool().isRequired,
    onChangeCompleteInputRange: propFunc().isRequired,
    onChangeInputRange: propFunc().isRequired,
};
export default RightComponentSpCharmPoint;
